

export class SolicitudCpeLugarProduccionViewModel {

    constructor() {

    }

    public Id: number;
    public IdEstado: number = 0;
    public IdEstadoDescripcion: string;
    public Codigo: string;
    public IdComunidadAutonoma: number;
    public TwParcelasCertificadoPrevioExCollection: TwParcelasCpeViewModel[];
    public TwLugarProduccionCertificadoPrevioEx: TwLugarProduccionCpeViewModel;
}

export class TwParcelasCpeViewModel {
    public Id: number;
    public IdSolicitudAtestFito: number;
    public CodigoSigPac: string;
    public SuperficieSigPac: number;
    public UsoSigPac: string;
    public IdProvinciaParcela: number;
    public IdMunicipioParcela: number | null;
    public DireccionParcela: string;
    public ProvinciaParcelaDescripcion: string;
    public MunicipioParcelaDescripcion: string;
}

export class TwLugarProduccionCpeViewModel {
    public IdCertPrevioEx: number;
    public LugarProduccion: string;
    public IdProvinciaLugar: number | null;
}

//export class RecintoInfoRequestViewModel {
//    public Provincia: string;
//    public Municipio: string;
//    public Agregado: string;
//    public Zona: string;
//    public Poligono: string;
//    public Parcela: string;
//    public Recinto: string;
//}

//export class ParcelaSimplifVerificadaSigpacViewModel {
//    public Superficie: number;
//    public Uso_sigpac: string;
//}
